var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainingBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9421 37.1408C24.0275 37.0594 24.1292 36.9984 24.231 36.9577V33.1369H0.854492C0.382487 33.1369 0 32.7544 0 32.2824C0 31.8104 0.382487 31.4279 0.854492 31.4279H4.55322V5.13393H0.854492C0.382487 5.13393 0 4.75144 0 4.27944C0 3.80743 0.382487 3.42495 0.854492 3.42495H24.0967V0.926575C24.0967 0.454569 24.4792 0.0720825 24.9512 0.0720825C25.4232 0.0720825 25.8057 0.454569 25.8057 0.926575V3.42495H49.0479C49.5199 3.42495 49.9023 3.80743 49.9023 4.27944C49.9023 4.75144 49.5199 5.13393 49.0479 5.13393H45.4061V31.4279H49.1414C49.6134 31.4279 49.9959 31.8104 49.9959 32.2824C49.9959 32.7544 49.6134 33.1369 49.1414 33.1369H25.9399V37.0431C25.9806 37.0716 26.0213 37.1001 26.0579 37.1367L31.3965 42.2148C31.7383 42.5403 31.7505 43.0775 31.425 43.4193C31.0994 43.761 30.5623 43.7733 30.2205 43.4477L25.9399 39.3787V43.0734C25.9399 43.5454 25.5575 43.9279 25.0855 43.9279C24.6134 43.9279 24.231 43.5454 24.231 43.0734V39.216L19.7754 43.4518C19.4336 43.7773 18.8924 43.761 18.571 43.4233C18.2454 43.0815 18.2577 42.5403 18.5994 42.2189L23.9421 37.1408ZM43.6971 31.4279V5.13393H6.26221V31.4279H43.6971Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 43.8558,
    fill: "white",
    transform: "translate(0 0.0720825)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingBoardIcon);
export default __webpack_public_path__ + "static/media/training-board-icon.26fbf7a602187e52871f03bf671ebb1f.svg";
export { ForwardRef as ReactComponent };